import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {urlJoin} from '../../../utils/urlJoin';
import {environment} from '../../../../environments/environment';


@Injectable()
export class FournisseurDetailService {
    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'portail');
    }


    /*   loadData(options) {
        const resource = urlJoin(FournisseurDetailService.base, 'vUmCategorieStatus','data');

        return this.http.post(resource,options);

      } */

    loadData(options) {
        const resource = urlJoin(FournisseurDetailService.base, 'vUmCategorieStatus', 'searchWithPagination');

        return this.http.post(resource, options);

    }


    /*  loadcard(id){
       const resource = urlJoin(FournisseurDetailService.base, 'ptLaw',id);
       return this.http.get(resource);



     } */


}





 


  

